<div class="full-width py-2 px-3" fxLayout="column" fxLayoutAlign="start start">
  <div class="full-width" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px">
    <div class="full-width mb-0" fxLayout="row" fxLayoutAlign="end center">
      <button class="button-close-top" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="full-width" fxLayout="row" fxLayoutAlign="space-between start">
    <div class="heading-default">Point-of-sales-software settings</div>
    <div class="pe-3" fxLayout="row" fxLayoutAlign="center center" *ngIf="loading$ | async">
      <mat-spinner color="primary" diameter="20"></mat-spinner>
    </div>
  </div>

  <div fxLayout="column" class="full-width" fxLayoutGap="15px" [fxFlexOffset]="showSingleLeaseSections ? '0' : '20px'">

    <!-- Defined once: the VEND/POSTER form renders this inside its first accordion panel,
         every other payment source renders it directly above its own fields. -->
    <ng-template #paymentSourceField>
      <div fxLayout="column" fxLayoutGap="10px">
        <div fxLayout="column">
          <span class="body-3-default">Payment Source Name</span>
          <span class="body-2-default">The point-of-sale software through which sales and inventory will be recorded.</span>
        </div>
        <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
          <mat-select class="custom-select-field-value" placeholder="Select"
                      (ngModelChange)="changePosType($event)" [(ngModel)]="posType"
                      [disabled]="isEditing">
            <mat-option class="custom-select-field-option" *ngFor="let type of allowedPosTypes"
                        [value]="type.source">{{ type.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-template>

    <ng-container *ngIf="!showSingleLeaseSections">
      <ng-container *ngTemplateOutlet="paymentSourceField"></ng-container>
    </ng-container>

    <div class="pos-dialog-scroll full-width" fxLayout="column" fxLayoutGap="15px">

    <!-- NETCASH    -->
    <div *ngIf="(posType === TransactionSource.NETCASH && singleLeaseConfig)" fxLayout="column" fxLayoutGap="15px">
      <div fxLayout="column" fxLayoutGap="10px">

        <div class="body-3-default">Select start and end dates for the configuration</div>
        <div fxFlexAlign="space-between center" fxLayout="row" fxLayoutGap="15px">

          <div fxFlex="50" fxLayout="column" fxLayoutGap="10px">
            <div fxLayout="column">
              <span class="body-2-default">Start date is required *</span>
            </div>
            <mat-form-field appearance="outline" class="custom-date-picker full-width" floatLabel="always">
              <mat-label>Start Date</mat-label>
              <input (ngModelChange)="onStartDateChange($event, 'single_lease')"
                     [(ngModel)]="singleLeaseConfig.startDate"
                     [matDatepicker]="startPicker"
                     [max]="startDateMaxValue('single_lease')"
                     [min]="startDateMinValue('single_lease')"
                     matInput
                     placeholder="select"
              />
              <mat-datepicker-toggle [for]="startPicker" matIconSuffix>
                <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div fxFlex="50" fxLayout="column" fxLayoutGap="10px">
            <div fxLayout="column">
              <span class="body-2-default">End date is optional and can be left blank</span>
            </div>
            <mat-form-field appearance="outline" class="custom-date-picker full-width" floatLabel="always">
              <mat-label>End Date</mat-label>
              <input (ngModelChange)="onEndDateChange($event, 'single_lease')" [(ngModel)]="singleLeaseConfig.endDate"
                     [matDatepicker]="endPicker"
                     [max]="endDateMaxValue('single_lease')"
                     [min]="endDateMinValue('single_lease')"
                     matInput
                     placeholder="select"/>
              <mat-datepicker-toggle [for]="endPicker" matIconSuffix>
                <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="column" fxLayoutGap="10px">
          <div fxLayout="column">
            <span class="body-3-default">Payment Provider Name</span>
            <span class="body-2-default">The software through which sale payments will take place (e.g. card machine).</span>
          </div>
          <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
            <mat-select class="custom-select-field-value" placeholder="Select"
                        [(ngModel)]="singleLeaseConfig.paymentTypeName"
                        [disabled]="!this.canEdit || (isEditing && !this.isNewEdit) || !!(loading$ | async)">
              <mat-option class="custom-select-field-option" *ngFor="let type of allowedPaymentTypes"
                          [value]="type.source">{{ type.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxLayout="column">
          <span class="body-3-default">Enter transaction reference</span>
        </div>

        <mat-form-field class="custom-select-field full-width" appearance="outline" style="width:100%!important;">
          <input type="text"
                 matInput
                 [matAutocomplete]="auto"
                 [formControl]="netCashReferenceCtrl"
                 (keydown.enter)="addTransactionReference()"
                 placeholder="Select or add transaction reference"/>

          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectItem($event)">
            <mat-option *ngFor="let item of singleLeaseConfig.transactionReferences" [value]="item">
              <div fxFlexAlign="space-between center" fxLayout="row" fxLayoutGap="10px">
                <span>{{ item }}</span>
                <button class="button-close-top" mat-icon-button color="warn"
                        (click)="removeTransactionReference(item); $event.stopPropagation()" aria-label="Remove item">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <!--single lease specific-->
    <mat-accordion *ngIf="showSingleLeaseSections" class="full-width compact-accordion">

      <!-- 1 — payment source and the configuration period -->
      <mat-expansion-panel [expanded]="true" data-test="panel-source-and-dates">
        <mat-expansion-panel-header>
          <mat-panel-title class="body-3-default expansion-panel-title">Payment source and dates</mat-panel-title>
        </mat-expansion-panel-header>

        <div fxLayout="column" fxLayoutGap="15px">
          <ng-container *ngTemplateOutlet="paymentSourceField"></ng-container>

          <div fxLayout="column" fxLayoutGap="10px" *ngIf="offeringConfig">
            <div fxLayout="column">
              <span class="body-3-default">Display Name</span>
              <span class="body-2-default">A display name for this config to make it more easily identifiable when applying to a lease.</span>
            </div>
            <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%;">
              <input [(ngModel)]="singleLeaseConfig!.displayName!" [disabled]="!this.canEdit || (isEditing && !this.isNewEdit)" matInput
                     type="text">
            </mat-form-field>
          </div>

          <div class="body-3-default">Select start and end dates for the configuration</div>
          <div fxFlexAlign="space-between center" fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="50" fxLayout="column" fxLayoutGap="10px">
              <div fxLayout="column">
                <span class="body-2-default">Start date is required *</span>
              </div>
              <mat-form-field appearance="outline" class="custom-date-picker full-width" floatLabel="always">
                <mat-label>Start Date</mat-label>
                <input (ngModelChange)="onStartDateChange($event, 'single_lease')" [(ngModel)]="singleLeaseConfig!.startDate"
                       [matDatepicker]="startPicker"
                       [max]="startDateMaxValue('single_lease')"
                       [min]="startDateMinValue('single_lease')"
                       matInput
                       placeholder="select"
                />
                <mat-datepicker-toggle [for]="startPicker" matIconSuffix>
                  <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex="50" fxLayout="column" fxLayoutGap="10px">
              <div fxLayout="column">
                <span class="body-2-default">End date is optional and can be left blank</span>
              </div>
              <mat-form-field appearance="outline" class="custom-date-picker full-width" floatLabel="always">
                <mat-label>End Date</mat-label>
                <input (ngModelChange)="onEndDateChange($event, 'single_lease')" [(ngModel)]="singleLeaseConfig!.endDate"
                       [matDatepicker]="endPicker"
                       [max]="endDateMaxValue('single_lease')"
                       [min]="endDateMinValue('single_lease')"
                       matInput
                       placeholder="select"/>
                <mat-datepicker-toggle [for]="endPicker" matIconSuffix>
                  <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- 2 — the point-of-sale account connection details -->
      <mat-expansion-panel data-test="panel-connection">
        <mat-expansion-panel-header>
          <mat-panel-title class="body-3-default expansion-panel-title">Point-of-sale connection</mat-panel-title>
          <mat-panel-description class="link-error" *ngIf="billingDayOfMonthInvalid">
            {{ billingDayOfMonthErrorMessage }}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="column" fxLayoutGap="15px">
          <div fxLayout="row" fxLayoutGap="15px">
            <div fxLayout="column" fxLayoutGap="10px" fxFlex="50">
              <div fxLayout="column">
                <span class="body-3-default">Domain Prefix</span>
                <span class="body-2-default">The domain prefix assigned on the point-of-sale software.</span>
              </div>
              <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%;">
                <input matInput type="text"
                       [(ngModel)]="singleLeaseConfig!.domainPrefix!"
                       [disabled]="!this.canEdit || (isEditing && !this.isNewEdit)">
              </mat-form-field>
            </div>

            <div fxLayout="column" fxLayoutGap="10px" fxFlex="50">
              <div fxLayout="column">
                <span class="body-3-default">Outlet ID</span>
                <span class="body-2-default">The outlet ID for this location on the point-of-sale software.</span>
              </div>
              <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%;">
                <input matInput type="text"
                       [(ngModel)]="singleLeaseConfig!.outletId!"
                       [disabled]="!this.canEdit || (isEditing && !this.isNewEdit) || !!(loading$ | async)">
              </mat-form-field>
            </div>
          </div>

          <div fxLayout="column" fxLayoutGap="10px">
            <div fxLayout="column">
              <span class="body-3-default">Access Token</span>
              <span class="body-2-default">The unique access token/key assigned on the point-of-sale software.</span>
            </div>
            <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%;">
              <input matInput
                     [type]="this.canEdit ? 'text' : 'password'"
                     [(ngModel)]="singleLeaseConfig!.accessToken!"
                     [disabled]="!this.canEdit || (isEditing && !this.isNewEdit)">
            </mat-form-field>
          </div>

          <!-- CS-1369 — Lightspeed plan renewal day. VEND only; optional. -->
          <div fxLayout="column" fxLayoutGap="10px" *ngIf="showBillingDayOfMonth">
            <div fxLayout="column">
              <span class="body-3-default">Plan Renewal Date</span>
              <span class="body-2-default">The day of the month the Lightspeed plan renews and bills (e.g. 25). Optional — leave blank if it is not known yet.</span>
            </div>
            <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%;"
                            data-test="billing-day-of-month">
              <input matInput type="number" step="1"
                     [min]="1" [max]="31"
                     placeholder="Day of the month"
                     [formControl]="billingDayOfMonthCtrl">
              <mat-error class="link-error">{{ billingDayOfMonthErrorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- 3 — admin login details -->
      <mat-expansion-panel data-test="panel-login">
        <mat-expansion-panel-header>
          <mat-panel-title class="body-3-default expansion-panel-title">Admin login details</mat-panel-title>
        </mat-expansion-panel-header>

        <div fxLayout="column" fxLayoutGap="15px">
          <div fxLayout="row" fxLayoutGap="15px">
            <div fxLayout="column" fxLayoutGap="10px" fxFlex="50">
              <div fxLayout="column">
                <span class="body-3-default">Login Username</span>
                <span class="body-2-default">The username for the admin account on the point-of-sale software.</span>
              </div>
              <mat-form-field class="custom-text-field" appearance="outline" *ngIf="this.canEdit" style="width: 100%;">
                <input [(ngModel)]="singleLeaseConfig!.loginUsername!" matInput type="text">
              </mat-form-field>
            </div>

            <div fxLayout="column" fxLayoutGap="10px" fxFlex="50">
              <div fxLayout="column">
                <span class="body-3-default">Login Password</span>
                <span class="body-2-default">The password for the admin account on the point-of-sale software.</span>
              </div>
              <mat-form-field class="custom-text-field" appearance="outline" *ngIf="this.canEdit" style="width: 100%;"
                              [cdkCopyToClipboard]="singleLeaseConfig!.loginPassword!"
                              [matTooltip]="!isEditing ? 'Click to copy password' : ''">
                <input [(ngModel)]="singleLeaseConfig!.loginPassword!" matInput type="'password'">
              </mat-form-field>
            </div>
          </div>

          <div fxLayout="column" fxLayoutGap="10px">
            <div fxLayout="column">
              <span class="body-3-default">Login URL</span>
              <span class="body-2-default">The login URL for the admin account on the point-of-sale software.</span>
            </div>
            <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%;"
                            *ngIf="this.canEdit">
              <input [(ngModel)]="singleLeaseConfig!.loginUrl" matInput type="text">
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- 4 — payment provider -->
      <mat-expansion-panel data-test="panel-payment-provider">
        <mat-expansion-panel-header>
          <mat-panel-title class="body-3-default expansion-panel-title">Payment provider</mat-panel-title>
        </mat-expansion-panel-header>

        <div fxLayout="column" fxLayoutGap="10px">
          <div fxLayout="column">
            <span class="body-3-default">Payment Provider Name</span>
            <span class="body-2-default">The software through which sale payments will take place (e.g. card machine).</span>
          </div>
          <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
            <mat-select class="custom-select-field-value" placeholder="Select"
                        [(ngModel)]="singleLeaseConfig!.paymentTypeName"
                        [disabled]="!this.canEdit || (isEditing && !this.isNewEdit) || !!(loading$ | async)">
              <mat-option class="custom-select-field-option" *ngFor="let type of paymentTypes"
                          [value]="type.source">{{ type.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-expansion-panel>

    </mat-accordion>

    <!--  offering  supplier specific-->
    <div *ngIf="posType == TransactionSource.VEND_SUPPLIER_OFFERING && supplierConfig && offeringSupplierConfigs" fxLayout="column"
         fxLayoutGap="15px">
      <div class="body-3-default">Select start and end dates for the configuration</div>
      <div fxFlexAlign="space-between center" fxLayout="row" fxLayoutGap="15px">

        <div fxFlex="50" fxLayout="column" fxLayoutGap="10px">
          <div fxLayout="column">
            <span class="body-2-default">Start date is required *</span>
          </div>
          <mat-form-field appearance="outline" class="custom-date-picker full-width" floatLabel="always">
            <mat-label>Start Date</mat-label>
            <input (ngModelChange)="onStartDateChange($event, 'supplier_lease')" [(ngModel)]="supplierConfig.startDate"
                   [matDatepicker]="startPicker"
                   [max]="startDateMaxValue('supplier_lease')"
                   [min]="startDateMinValue('supplier_lease')"
                   matInput
                   placeholder="select"
            />
            <mat-datepicker-toggle [for]="startPicker" matIconSuffix>
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxLayout="column" fxLayoutGap="10px">
          <div fxLayout="column">
            <span class="body-2-default">End date is optional and can be left blank</span>
          </div>
          <mat-form-field appearance="outline" class="custom-date-picker full-width" floatLabel="always">
            <mat-label>End Date</mat-label>
            <input (ngModelChange)="onEndDateChange($event, 'supplier_lease')" [(ngModel)]="supplierConfig.endDate"
                   [matDatepicker]="endPicker"
                   [max]="endDateMaxValue('supplier_lease')"
                   [min]="endDateMinValue('supplier_lease')"
                   matInput
                   placeholder="select"/>
            <mat-datepicker-toggle [for]="endPicker" matIconSuffix>
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="column" fxLayoutGap="10px">
        <div fxLayout="column">
          <span class="body-3-default">Parent Transaction Source</span>
          <span class="body-2-default">The name of the parent point-of-sale config to which this lease will be a linked supplier.</span>
        </div>
        <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
          <mat-select class="custom-select-field-value" placeholder="Select"
                      [disabled]="!this.canEdit || isEditing || !!(loading$ | async)"
                      [(ngModel)]="supplierConfig.paymentConfigUuid" (ngModelChange)="loadConfigSuppliers($event, posType)">
            <mat-option *ngFor="let config of offeringSupplierConfigs" class="custom-select-field-option"
                        [value]="config.uuid">{{ config.label }} ({{config.code}})</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div fxLayout="column" fxLayoutGap="10px">
        <div fxLayout="column">
          <span class="body-3-default">Available Suppliers</span>
          <span class="body-2-default">The names of the suppliers which this lease will be trading under which are linked to the parent transaction source.</span>
        </div>
        <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
          <mat-select class="custom-select-field-value" placeholder="Select" [multiple]="true"
                      [disabled]="!this.canEdit || !!(loading$ | async)"
                      [(ngModel)]="supplierConfig.suppliers">
            <mat-option class="custom-select-field-option" *ngFor="let supplier of availableSuppliers"
                        [value]="supplier">{{ supplier.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!--    lease supplier specific-->
    <div fxLayout="column" fxLayoutGap="15px" *ngIf="posType == TransactionSource.VEND_SUPPLIER_LEASE && supplierConfig">

      <div fxLayout="column" fxLayoutGap="10px">
        <div fxLayout="column">
          <span class="body-3-default">Parent Transaction Source</span>
          <span class="body-2-default">The name of the parent point-of-sale config to which this lease will be a linked supplier.</span>
        </div>
        <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
          <mat-select class="custom-select-field-value" placeholder="Select"
                      [disabled]="!this.canEdit || isEditing || !!(loading$ | async)"
                      [(ngModel)]="supplierConfig.paymentConfigUuid" (ngModelChange)="loadConfigSuppliers($event, posType)">
            <mat-option *ngFor="let config of supplierLeaseConfigs" class="custom-select-field-option"
                        [value]="config.uuid">{{ config.label }} ({{config.code}})</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="body-3-default">Select start and end dates for the configuration</div>
      <div fxFlexAlign="space-between center" fxLayout="row" fxLayoutGap="15px">

        <div fxFlex="50" fxLayout="column" fxLayoutGap="10px">
          <div fxLayout="column">
            <span class="body-2-default">Start date is required *</span>
          </div>
          <mat-form-field appearance="outline" class="custom-date-picker full-width" floatLabel="always">
            <mat-label>Start Date</mat-label>
            <input (ngModelChange)="onStartDateChange($event, 'supplier_lease')" [(ngModel)]="supplierConfig.startDate"
                   [matDatepicker]="startPicker"
                   [max]="startDateMaxValue('supplier_lease')"
                   [min]="startDateMinValue('supplier_lease')"
                   matInput
                   placeholder="select"
            />
            <mat-datepicker-toggle [for]="startPicker" matIconSuffix>
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxLayout="column" fxLayoutGap="10px">
          <div fxLayout="column">
            <span class="body-2-default">End date is optional and can be left blank</span>
          </div>
          <mat-form-field appearance="outline" class="custom-date-picker full-width" floatLabel="always">
            <mat-label>End Date</mat-label>
            <input (ngModelChange)="onEndDateChange($event, 'supplier_lease')" [(ngModel)]="supplierConfig.endDate"
                   [matDatepicker]="endPicker"
                   [max]="endDateMaxValue('supplier_lease')"
                   [min]="endDateMinValue('supplier_lease')"
                   matInput
                   placeholder="select"/>
            <mat-datepicker-toggle [for]="endPicker" matIconSuffix>
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="column" fxLayoutGap="10px">
        <div fxLayout="column">
          <span class="body-3-default">Available Suppliers</span>
          <span class="body-2-default">The names of the suppliers linked to the parent payment source which this lease will be trading under.</span>
        </div>
        <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
          <mat-select class="custom-select-field-value" placeholder="Select" [multiple]="true"
                      [disabled]="!this.canEdit || !!(loading$ | async)"
                      [(ngModel)]="supplierConfig.suppliers">
            <mat-option class="custom-select-field-option" *ngFor="let supplier of getAvailableSuppliers(availableSuppliers)"
                        [value]="supplier">{{ supplier.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    </div>
    <!-- /pos-dialog-scroll — the actions stay outside so they never scroll out of reach -->

    <div class="full-width" fxLayout="row" fxLayoutAlign="end" fxFlexOffset="20px" fxLayoutGap="20px">
      <button mat-flat-button class="button-outline button-primary" (click)="cancelChanges()">
        <div class="button-text">Cancel</div>
      </button>
      <button mat-flat-button class="button-primary" [disabled]="!canSave" (click)="saveChanges()">
        <div class="button-text">Save</div>
      </button>
    </div>
  </div>
</div>
